export const useGeolocation = () => {
  return {
    /**
     * CS-8234 緯度経度取得
     */
    getLatLng: async () => {
      return await new Promise<{ lat: number; lng: number }>((resolve, reject) => {
        console.log(
          navigator.geolocation ? 'GeolocationAPIを利用できる環境です' : 'GeolocationAPIは利用できない環境です'
        );

        const errorCallback = (e: any) => {
          console.log(`ERROR(${e.code}): ${e.message}`);
          reject(e);
        };

        // Working with W3C Geolocation API
        navigator.geolocation.getCurrentPosition(
          position => {
            const { latitude, longitude } = position.coords;
            resolve({ lat: latitude, lng: longitude });
          },
          errorCallback,
          // @see https://developer.mozilla.org/ja/docs/Web/API/Geolocation/getCurrentPosition#options
          {
            enableHighAccuracy: false,
            timeout: 3000,
            maximumAge: 0,
          }
        );
      });
    },
  };
};
